import React, { createContext, useContext, useState, useCallback } from "react";
import { api, store, TOKEN_KEY, USER_KEY } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = store.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  });

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    store.setItem(TOKEN_KEY, res.data.access_token);
    store.setItem(USER_KEY, JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    store.removeItem(TOKEN_KEY);
    store.removeItem(USER_KEY);
    setUser(null);
  }, []);

  const isOwner = user?.role === "owner";
  const isStaff = user?.role === "staff";

  return (
    <AuthCtx.Provider value={{ user, login, logout, isOwner, isStaff }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
